import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import type { Dispatch } from '@swf/core/store';

import { HGToastType } from '../types/common';

const usePublicClubsRestricted = () => {
  const history = useHistory();
  const { localSettings } = useDispatch<Dispatch>();

  const showClubRestrictedToast = useCallback((redirectTo = '') => {
    localSettings.set({
      homegames: { toastMessage: { [HGToastType.JoinAndCreateClubToast]: { isHidden: false } } }
    });

    if (redirectTo) history.push(redirectTo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { showClubRestrictedToast };
};

export default usePublicClubsRestricted;
